import {BaseEntity} from "../common/base-entity";
import {FormControl} from "rx-form-mapper";

export class Address extends BaseEntity {

    static readonly ADDRESS_LINE_DEFAULT_MAX_LENGTH = 49; //default address length for most addresses (including Ontario Subject Property)

    constructor(address?: Address) {
        super(address);
        if(address){
            if(address.country){
                //country field comes from unity as Canada or CANADA
                this.country = this.country.toUpperCase();
            } else {
                this.country = 'CANADA';
            }
        }
        if(!this.addressLine1){
            this.addressLine1 = '';
        }
        if(!this.addressLine2){
            this.addressLine2 = '';
        }
        if(!this.addressTypeCode){
            this.addressTypeCode = '';
        }
        if(!this.city){
            this.city = '';
        }
        if(!this.country){
            this.country = 'CANADA';
        }
        if(!this.postalCode){
            this.postalCode = '';
        }
        if(!this.provinceCode){
            this.provinceCode = '';
        } else {
            this.updateProvinceNameFromProvinceCode();
        }
    }

    updateProvinceNameFromProvinceCode() {
        const provinceName = Address.provinceCodeToProvinceName(this.provinceCode);
        if (provinceName) {
            this.provinceName = provinceName;
        }
    }

    static provinceCodeToProvinceName(provinceCode: string) {
        switch(provinceCode) {
            case  'AB': return 'Alberta';
            case  'BC': return 'British Columbia';
            case  'MB': return 'Manitoba';
            case  'NL': return 'Newfoundland and Labrador';
            case  'NB': return 'New Brunswick';
            case  'NT': return 'Northwest Territories';
            case  'NS': return 'Nova Scotia';
            case  'NU': return 'Nunavut';
            case  'ON': return 'Ontario';
            case  'PE': return 'Prince Edward Island';
            case  'QC': return 'Quebec';
            case  'SK': return 'Saskatchewan'
            case  'YT': return 'Yukon';
            default: return '';
        }
    }

    id: number;
    @FormControl()
    addressLine1: any; //Changed the type of addressLine1 from String to any as same field is bound to auto-complete
    @FormControl()
    addressLine2: string;
    addressTypeCode: string;
    sameAsAddressTypeCode : string;
    @FormControl()
    city: string;
    @FormControl()
    country: string;
    @FormControl()
    postalCode: string;
    provinceName: string;
    @FormControl()
    provinceCode: string;

    get isEmpty(): boolean {
        return !this.addressLine1
            && !this.addressLine2
            && !this.city
            && !this.postalCode;
    }

   public getAddressText(useCity : boolean, useProvinceName: boolean, useCountryName: boolean, usePostalCode: boolean): string {
        return (typeof this.addressLine1 == 'object' || !this.addressLine1 ? '' : this.addressLine1 || '') +
            (this.addressLine2 ? ', ' + this.addressLine2 : '') +
            (useCity && this.city ? ', ' + this.city : '') +
            (useProvinceName && this.provinceName? ', ' + this.provinceName : '') +
            (useCountryName && !this.isCountryCanada && this.country ? ', ' + this.country : '') +
            (usePostalCode && this.postalCode ? ' ' + this.postalCode : '');
    }

    get fullAddress(): string {
        return this.getAddressText(true, true, true, true);
    }

    get isCountryCanada(): boolean {
        return this.country && (this.country.toUpperCase() === 'CANADA' || this.country.toUpperCase() === 'CA')
    }

    get entityName() : string {
        return 'address';
    }

}
